import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/lib/data";
import { useDemoModal } from "@/components/DemoModalContext";

export default function ReferenceModal({ item, onClose }) {
  const { setOpen: setDemoOpen } = useDemoModal();

  const openDemo = () => {
    onClose();
    setTimeout(() => setDemoOpen(true), 180);
  };

  const modalContent = (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] flex items-center justify-center p-4"
        >
          <div
            className="absolute inset-0 bg-ink/60 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.98 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative z-10 max-h-[92vh] w-full max-w-xl overflow-y-auto rounded-3xl bg-white p-6 shadow-[0_40px_100px_rgba(0,0,0,0.25)] md:p-8"
          >
            <button
              onClick={onClose}
              aria-label="Kapat"
              className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-full bg-cloud text-ink/60 transition-colors hover:bg-ink/10"
            >
              <X className="h-4.5 w-4.5" />
            </button>

            {/* Image */}
            <div className="flex h-40 w-full items-center justify-center rounded-2xl bg-cloud sm:h-48">
              <img
                src={item.image}
                alt={item.name}
                className="h-full w-full object-contain p-5"
              />
            </div>

            {/* Content */}
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <h3 className="text-2xl font-extrabold tracking-tight text-ink">
                {item.name}
              </h3>
              <span className="rounded-full bg-lime/15 px-2.5 py-0.5 text-xs font-bold text-lime-700">
                {item.sector}
              </span>
            </div>

            <p className="mt-4 text-base leading-relaxed text-ink/70">
              {item.desc}
            </p>

            <div className="mt-5 rounded-2xl bg-cloud p-4 text-sm text-ink/70">
              <span className="font-semibold text-ink">AKINSOFT entegrasyonu</span> ile
              işletmenizin dijital dönüşümünü hızlandırın. Siz de bu referanslar gibi
              verimliliği artırmak için hemen iletişime geçin.
            </div>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <button
                onClick={openDemo}
                className="btn-primary flex flex-1 items-center justify-center gap-2"
              >
                Demo Talebi <ArrowRight className="h-4 w-4" />
              </button>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="btn-secondary flex flex-1 items-center justify-center gap-2"
              >
                <Phone className="h-4 w-4" /> Bizi Arayın
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return createPortal(modalContent, document.body);
}
